module.exports = __webpack_public_path__ + "img/logo02.1dea7f6f.png";